import React from 'react'
import {
  ClearIndicatorProps,
  components,
  DropdownIndicatorProps,
  GroupBase,
  ValueContainerProps
} from "react-select";
import ChevronDown from "@/assets/icon/chevron-down.svg";
import Close from "@/assets/icon/close.svg";
import Search from "@/assets/icon/search.svg";

export function DropdownIndicator<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(props: DropdownIndicatorProps<Option, IsMulti, Group> ){
  return (
    <components.DropdownIndicator {...props}>
      <ChevronDown className="h-4 w-4" />
    </components.DropdownIndicator>
  );
};

export function DropdownSearchIndicator<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(props: DropdownIndicatorProps<Option, IsMulti, Group> ){
  return (
    <components.DropdownIndicator {...props}>
      <Search className="h-4 w-4" />
    </components.DropdownIndicator>
  );
};

export function ClearIndicator<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(props: ClearIndicatorProps<Option, IsMulti, Group> ){
  return (
    <components.ClearIndicator {...props}>
      <Close className="h-4 w-4" />
    </components.ClearIndicator>
  );
};

export function ValueContainer<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>({children, ...props}: ValueContainerProps<Option, IsMulti, Group>){
  return <components.ValueContainer {...props}>{children}</components.ValueContainer>
}

export function NoOptionsMessage({...props}: any) {
  return <components.NoOptionsMessage {...props}>Nichts gefunden.</components.NoOptionsMessage>
}
